module.exports = __webpack_public_path__ + "static/hustawki_thumb-018e403af96dbf66b5a6cb0a5e160cf8.jpg";